"use strict";

exports.__esModule = true;
exports.UI_SCREENS = exports.UI_RESET = exports.UI_OVERRIDE_STORAGE_KEY = exports.UI_OVERRIDE_PARAM = exports.UI_MODERN = exports.UI_LEGACY = void 0;
exports.clearUiOverride = clearUiOverride;
exports.readUiOverrideParam = readUiOverrideParam;
exports.removeUiOverrideFromUrl = removeUiOverrideFromUrl;
exports.resolveUiDesign = resolveUiDesign;
var _featureFlags = require("../../../featureFlags");
/**
 * The screens that can opt in to the modern UI, by the name a
 * UiDesignProvider is given, and the flag each one needs.
 */
var UI_SCREENS = exports.UI_SCREENS = {
  dashboard: _featureFlags.ENABLE_MODERN_UI_DASHBOARD,
  reports: _featureFlags.ENABLE_MODERN_UI_REPORTS,
  "operator-panel": _featureFlags.ENABLE_MODERN_UI_OPERATOR_PANEL,
  "knowledge-base": _featureFlags.ENABLE_MODERN_UI_KNOWLEDGE_BASE,
  "device-data": _featureFlags.ENABLE_MODERN_UI_DEVICE_DATA,
  "maintenance-manager": _featureFlags.ENABLE_MODERN_UI_MAINTENANCE_MANAGER
};
var UI_OVERRIDE_PARAM = exports.UI_OVERRIDE_PARAM = "ui";
var UI_OVERRIDE_STORAGE_KEY = exports.UI_OVERRIDE_STORAGE_KEY = "vi.uiDesign";
var UI_MODERN = exports.UI_MODERN = "modern";
var UI_LEGACY = exports.UI_LEGACY = "legacy";
var UI_RESET = exports.UI_RESET = "reset";

/**
 * The only place the modern-UI flags are read. Returns whether `screen`
 * (or the global chrome when no screen is given) renders the modern UI.
 *
 * - No master flag: never modern, whatever else is set.
 * - Master flag alone: modern chrome; screens stay legacy until their own
 *   flag is set too.
 * - An explicit override ("modern" or "legacy"), when a caller passes one and
 *   the environment carries ENABLE_MODERN_UI_OVERRIDE, wins. The app passes
 *   none: ?ui= becomes a preference instead, so what renders always matches
 *   what the switch and the dialog show.
 */
function resolveUiDesign(featureFlags, screen, override) {
  var flags = Array.isArray(featureFlags) ? featureFlags : [];
  var has = function has(flag) {
    return flags.includes(flag);
  };
  if (override && has(_featureFlags.ENABLE_MODERN_UI_OVERRIDE)) {
    return override === UI_MODERN;
  }
  if (!has(_featureFlags.ENABLE_MODERN_UI)) {
    return false;
  }
  if (screen === undefined || screen === null) {
    return true;
  }
  var screenFlag = UI_SCREENS[screen];
  return Boolean(screenFlag) && has(screenFlag);
}
function queryValue(search, key) {
  if (!search) {
    return null;
  }
  var params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  return params.get(key);
}

/**
 * The ?ui= request on the current URL (before or after the hash):
 * "modern", "legacy", "reset" or null. It is never stored: the
 * UiPreferencesProvider writes it into the user's preference record, the
 * single source of truth, and strips it from the URL. Safe without a window.
 */
function readUiOverrideParam(location) {
  if (location === void 0) {
    location = typeof window !== "undefined" ? window.location : null;
  }
  if (!location) {
    return null;
  }
  var requested = queryValue(location.search, UI_OVERRIDE_PARAM);
  if (requested == null && location.hash && location.hash.includes("?")) {
    requested = queryValue(location.hash.slice(location.hash.indexOf("?")), UI_OVERRIDE_PARAM);
  }
  return requested === UI_MODERN || requested === UI_LEGACY || requested === UI_RESET ? requested : null;
}

/**
 * Remove the pin an earlier build kept under its own key. Rendering no longer
 * reads it, so a browser that still carries one must not keep a stale value.
 */
function clearUiOverride(storage) {
  if (storage === void 0) {
    storage = typeof window !== "undefined" ? window.localStorage : null;
  }
  try {
    storage && storage.removeItem(UI_OVERRIDE_STORAGE_KEY);
  } catch (e) {
    // Blocked storage: nothing to forget.
  }
}
function stripParam(query, key) {
  if (!query) {
    return query;
  }
  var params = new URLSearchParams(query.startsWith("?") ? query.slice(1) : query);
  params["delete"](key);
  var rest = params.toString();
  return rest ? "?" + rest : "";
}

/**
 * Remove ?ui= from the current URL (search and hash) without navigating, so
 * a reload does not pin the browser again. Returns true when it changed
 * something.
 */
function removeUiOverrideFromUrl(location, history) {
  if (location === void 0) {
    location = typeof window !== "undefined" ? window.location : null;
  }
  if (history === void 0) {
    history = typeof window !== "undefined" ? window.history : null;
  }
  if (!location || !history) {
    return false;
  }
  var search = stripParam(location.search, UI_OVERRIDE_PARAM);
  var hash = location.hash || "";
  if (hash.includes("?")) {
    var at = hash.indexOf("?");
    hash = hash.slice(0, at) + stripParam(hash.slice(at), UI_OVERRIDE_PARAM);
  }
  if (search === (location.search || "") && hash === (location.hash || "")) {
    return false;
  }
  try {
    history.replaceState(null, "", "" + location.pathname + search + hash);
    return true;
  } catch (e) {
    return false;
  }
}